import { useQuery } from '@apollo/client';
import GET_CONTENT_RATING from '../graphql/GetContentRating.graphql';

export const useContentRating = (id: number | null | undefined) => {
	// If we successfully fetched this rating Server-Side, it was injected into the window cache.
	// We can instantly return it and completely bypass any Client-Side fetching!
	const serverSideCache = typeof window !== 'undefined' ? (window as any).__CONTENT_RATING_CACHE__?.[id as any] : null;

	const { data, loading, error } = useQuery(GET_CONTENT_RATING, {
		variables: { id },
		skip: !id || !!serverSideCache, // Completely skip the Apollo query if we have it in the server-side cache
		fetchPolicy: 'cache-first',
	});

	return {
		contentRating: serverSideCache || data?.content?.contentRating || null,
		loading: serverSideCache ? false : loading,
		error: serverSideCache ? undefined : error,
	};
};
